import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from './baseQuery';

/**
 * Base API Slice
 *
 * Needs to create this empty slice to minimize bundle size
 * We will be injecting endpoints in this api slice
 */
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery(),
  keepUnusedDataFor: 600, // Keeping unused data for at least 10 minutes
  tagTypes: ['User', 'EligibleModule'],
  endpoints: (builder) => ({
    queryData: builder.query<{ id: string; name: string }[], void>({
      query: () => ({
        url: 'posts',
      }),
    }),
  }),
});
